"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SearchFilters = require("../../../types/SearchFilters");

var suitableForBuilder = function suitableForBuilder(params) {
  var suitableFor = params.suitableFor;

  if (!suitableFor) {
    return '';
  }

  var queries = [];
  var students = suitableFor.includes(_SearchFilters.SuitableForValue.STUDENTS);
  var workingProfessionals = suitableFor.includes(_SearchFilters.SuitableForValue.WORKING_PROFESSIONALS);
  var couples = suitableFor.includes(_SearchFilters.SuitableForValue.COUPLES);

  if (students && !workingProfessionals) {
    queries.push("NOT facility_tenant_status:'working professionals only'");
  } else if (!students && workingProfessionals) {
    queries.push("NOT facility_tenant_status:'students only'");
  }

  if (couples) {
    queries.push('couplesAllowed:yes');
  }

  return queries.join(' AND ');
};

var _default = suitableForBuilder;
exports["default"] = _default;